import { MenuNode } from './menu.types';

export const MENU_TREE: MenuNode[] = [
  {
    key: 'administration',
    label: 'Administration',
    icon: 'person-circle',
    position: 0,
    children: [
      {
        key: 'orderStammdaten',
        label: 'Auftrag',
        icon: 'time',
        route: '/dayinfo',
        position: 0,
      },
      {
        key: 'timemodelStammdaten',
        label: 'Zeitmodelle',
        icon: 'calendar',
        route: '/dayinfo',
        position: 1,
      },
      {
        key: 'holidaymodelStammdaten',
        label: 'Ferienmodelle',
        icon: 'calendar',
        route: '/dayinfo',
        position: 2,
      },
      {
        key: 'customerStammdaten',
        label: 'Kunde',
        icon: 'calendar',
        route: '/dayinfo',
        position: 3,
      },
      {
        key: 'departmentStammdaten',
        label: 'Abteilung',
        icon: 'calendar',
        route: '/dayinfo',
        position: 4,
      },
      {
        key: 'costcenterStammdaten',
        label: 'Kostenstelle',
        icon: 'calendar',
        route: '/dayinfo',
        position: 5,
      },
    ],
  },
  {
    key: 'personal',
    label: 'Persönlich',
    icon: 'person-circle',
    position: 1,
    children: [
      {
        key: 'badge',
        label: 'mainMenu.badge',
        icon: 'time',
        route: '/badge',
        position: 0,
      },
      {
        key: 'dayOverview',
        label: 'mainMenu.overview',
        icon: 'calendar',
        route: '/dayinfo',
        position: 1,
      },
      {
        key: 'orders',
        label: 'order.addition',
        icon: 'build',
        route: '/orders',
        position: 2,
      },
      {
        key: 'reports',
        label: 'report.titleMultiple',
        icon: 'document-text',
        route: '/report',
        position: 3,
      },
      {
        key: 'absencePlanner',
        label: 'absencePlaner.title',
        icon: 'airplane',
        route: '/absence-planer',
        position: 4,
      },
    ],
  },
  {
    key: 'persons',
    label: 'personalList.title',
    icon: 'people-circle',
    route: '/persons',
    position: 2,
    children: [
      {
        key: 'absencePlannerPersons',
        label: 'absencePlaner.title',
        icon: 'airplane',
        route: '/absence-planer',
        position: 0,
      },
      {
        key: 'ordersAdmin',
        label: 'order.addition',
        icon: 'build',
        route: '/orders',
        position: 1,
      },
      {
        key: 'adminToolPerson',
        label: 'adminTools.personTools',
        position: 2,
        route: '/admin-tools-persons',
        icon: 'build',
      },
      {
        key: 'adminToolTimeModel',
        label: 'adminTools.batchMutation.timemodels.title',
        position: 3,
        route: '/admin-tools-timemodel',
        icon: 'build',
      },

      {
        key: 'adminToolHoliday',
        label: 'adminTools.batchMutation.holidays.title',
        position: 4,
        route: '/admin-tools-holiday',
        icon: 'build',
      },
      {
        key: 'workflow',
        label: 'workflow.title',
        icon: 'checkbox',
        route: '/workflow',
        position: 5,
      },
      {
        key: 'seriesPrint',
        label: 'Seriendruck',
        icon: 'print',
        route: '/reports',
        position: 6,
      },
      {
        key: 'presenceListReports',
        label: 'Auswertungen',
        icon: 'eye',
        route: '/report-single',
        position: 7,
      },
    ],
  },
  {
    key: 'logout',
    label: 'mainMenu.logout',
    icon: 'log-out',
    position: 99,
    action: 'logout',
  },
];
